import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-cx-button',
  templateUrl: './cx-button.component.html',
  styleUrls: ['./cx-button.component.scss']
})
export class CxButtonComponent implements OnInit {


  @Input()
  isPrimaryButton: boolean;

  @Input()
  messageText: string;

  @Input()
  isDisabled: boolean;
  
  constructor() { }

  ngOnInit(): void {
  }

}
